import { routes as Auth } from './Auth'
import { routes as Core } from './Core'
import { routes as Config } from './Config'
import { routes as Records } from './Records'
import { routes as Financial } from './Financial'
import { routes as Report } from './Report'
import { routes as Management } from './Management'
import { routes as FinancialManagement } from './FinancialManagement'
import { routes as Checkout } from './Checkout'

export default [
  ...Report,
  ...Financial,
  ...Records,
  ...Config,
  ...Core,
  ...Auth,
  ...Management,
  ...FinancialManagement,
  ...Checkout,
]
